<script setup lang="ts">
    import { computed } from 'vue';
    import { useValidationErrors } from '@/js/composables/useValidationErrors';
    import { __, __untypedExpression, hasExpression } from '@/js/stores/expressions';
    import { TriangleAlertIcon } from '@lucide/vue';

    const props = defineProps<{
        scope?: string;
    }>();

    const v = useValidationErrors(props.scope);

    const messages = computed(() => {
        const out: string[] = [];
        for (const msgs of Object.values(v.errors.value)) {
            for (const msg of msgs) {
                out.push(hasExpression(msg) ? __untypedExpression(msg) : msg);
            }
        }
        return out;
    });
</script>

<template>
    <div
        v-if="messages.length"
        role="alert"
        class="bg-white border border-error rounded-sm shadow-md p-4 my-4 flex gap-2.5"
    >
        <TriangleAlertIcon class="size-5 text-error shrink-0" />
        <div class="flex-1">
            <p class="text-body-bold text-error">
                {{ __('validation-summary-title') }}
            </p>
            <ul class="text-body mt-1 list-disc pl-3.5">
                <li v-for="(msg, i) in messages" :key="i">{{ msg }}</li>
            </ul>
        </div>
    </div>
</template>
